<template>
    <div>
        <h4>Історія змін по товарам</h4>

        <DataTable
            :value="data"
            v-model:selection="selectedCharacteristics"
            v-model:filters="filterParams.filters"
            filterDisplay="row"
            paginator
            lazy
            :rows="filterParams.perPage"
            :rowsPerPageOptions="[50, 100, 200]"
            :total-records="total"
            :loading="loading"
            @page="onPage($event)"
            @filter="getData()"
            class="customTable"
            @row-select-all="onSelectAllChange"
            @row-select="onRowSelect"
            @row-unselect="onRowUnselect"
        >
            <Column selectionMode="multiple" :class="{'select-all-selected': selectAll}" headerStyle="width: 3rem"></Column>
            <Column field="user_email" header="Користувач">
                <template #body="slotProps">
                    {{ slotProps.data.user_email }}
                </template>
                <template #filter>
                    <InputText v-model="filterParams.filters.user_email.value" type="text" @input="getData()" placeholder="Пошук" />
                </template>
            </Column>
            <Column field="product_name" header="Назва товару">
                <template #body="slotProps">
                    {{ slotProps.data.product_name }}
                </template>
                <template #filter>
                    <InputText v-model="filterParams.filters.product_name.value" type="text" @input="getData()" placeholder="Пошук" />
                </template>
            </Column>
            <Column field="entity" header="Змінилось">
                <template #body="slotProps">
                    {{ slotProps.data.entity }}
                </template>
                <template #filter>
                    <Dropdown v-model="filterParams.filters.entity.value" :options="entities" @change="getData()" optionLabel="name" optionValue="value" placeholder="Оберіть значення" />
                </template>
            </Column>
            <Column field="old_value" header="Старе значення">
                <template #body="slotProps">
                    {{ slotProps.data.old_value }}
                </template>
            </Column>
            <Column field="new_value" header="Нове значення">
                <template #body="slotProps">
                    {{ slotProps.data.new_value }}
                </template>
            </Column>
            <Column field="created_at" header="Дата">
                <template #body="slotProps">
                    {{ moment(slotProps.data.created_at).format("DD.MM.YYYY HH:mm") }}
                </template>
                <template #filter>
                    <Calendar v-model="filterParams.filters.created_at.value" selection-mode="range" dateFormat="mm/dd/yy" @update:modelValue="getData()" placeholder="Діапазон" />
                </template>
            </Column>
        </DataTable>
    </div>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import FileUpload from 'primevue/fileupload';
import Toast from 'primevue/toast';
import ProgressBar from 'primevue/progressbar';
import moment from "moment";
import Input from '../Jetstream/Input.vue';
import axios from "axios";
import Label from '../Jetstream/Label.vue';
import DataTable from "primevue/datatable";
import Column from 'primevue/column';
import {FilterMatchMode} from "primevue/api";
import InputText from 'primevue/inputtext';
import Dropdown from 'primevue/dropdown';
import Calendar from 'primevue/calendar';

export default {
    layout: AppLayout,
    data() {
        return {
            moment: moment,
            data: [],
            total: 0,
            selectedCharacteristics: [],
            filterParams: {
                page: 1,
                perPage: 50,
                filters: {
                    user_email: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    product_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    entity: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    created_at: { value: null, matchMode: FilterMatchMode.CONTAINS },
                }
            },
            loading: false,
            selectAll: false,
            entities: [
                {
                    value: 'Характеристика',
                    name: 'Характеристика'
                },
                {
                    value: 'Фото',
                    name: 'Фото'
                },
                {
                    value: 'Документи',
                    name: 'Документи'
                },
                {
                    value: 'Аксесуари',
                    name: 'Аксесуари'
                },
            ],
        }
    },
    mounted() {
        this.getData();
    },
    components: {
        ProgressBar,
        DataTable,
        InputText,
        Column,
        "p-fileupload": FileUpload,
        Toast,
        Input,
        Label,
        Dropdown,
        Calendar
    },
    methods: {
        getData() {
            this.loading = true
            axios.post(this.route('product_history.get'), this.filterParams).then(result => {
                this.data = result.data.data.data;
                this.total = result.data.data.total;
                this.loading = false
            });
        },
        onPage(event) {
            this.filterParams.page = event.page+1
            this.filterParams.perPage = event.rows
            this.getData()
        },
        onSelectAllChange() {
            if (this.data.length >= this.filterParams.perPage) {
                if (!this.selectAll) {
                    this.selectAll = true;
                    this.selectedCharacteristics = this.data
                } else {
                    this.selectAll = false;
                    this.selectedCharacteristics = [];
                }
            }
        },
        onRowSelect() {
            if (this.data.length >= this.filterParams.perPage) {
                this.selectAll = this.selectedCharacteristics.length === this.data.length
            }
        },
        onRowUnselect() {
            if (this.data.length >= this.filterParams.perPage) {
                this.selectAll = false;
            }
        }
    }
};
</script>
